import React from "react"
import { Container } from "react-responsive-grid"
import { rhythm, scale } from "../utils/typography"
import Link from "gatsby-link"
import './Footer.css';


class Footer extends React.Component {
  render() {
    const {showLogo} = this.props;

    return <footer style={{background: '#FBFBFB'}}><Container
      style={{
        maxWidth: rhythm(35),
        padding: `${rhythm(0.5)} ${rhythm(3 / 4)}`,
      }}
    >
      <ul>
        <li>
          © 2017-2022 Project Maple Ltd
        </li>
        <li><Link to={'/docs'}>Documentation</Link></li>
        <li><Link to={'/contact'}>Contact Us & Support</Link></li>
        <li><Link to={'/privacy'}>Privacy</Link></li>
      </ul>
      {this.props.children && <div style={{marginLeft: '20px'}}>{this.props.children}</div>}
    </Container></footer>
  }
}

Footer.propTypes = {
}

Footer.defaultProps = {
}

export default Footer;



// WEBPACK FOOTER //
// ./src/layouts/Footer.js